import { gql } from "@apollo/client";

export const GET_SUSPICIOUS_NUMBERS_BY_AGENT_ID = gql`
  query ($partnerAgentId: Int!) {
    suspiciousNumbersPerAgent(partnerAgentId: $partnerAgentId) {
      partnerAgentSuspiciousMobileId
      partnerAgent {
        partnerAgentId
        firstName
        lastName
      }
      agentMobile
      createdAt
      updatedAt
      deleted
    }
  }
`;

export const UPSERT_SUSPICIOUS_NUM_BY_AGENT_ID = gql`
  mutation (
    $input: SuspiciousNumberPerAgentInput!
    $partnerAgentSuspiciousMobileId: ID
  ) {
    upsertSuspiciousNumberToAgent(
      input: $input
      partnerAgentSuspiciousMobileId: $partnerAgentSuspiciousMobileId
    ) {
      suspiciousNumbersPerAgent {
        partnerAgentSuspiciousMobileId
        partnerAgent {
          agentName
        }
        agentMobile
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_SUPICIOUS_NUMBER_BY_AGENT = gql`
  mutation ($partnerAgentSuspiciousMobileId: ID!) {
    deleteSuspiciousNumber(
      partnerAgentSuspiciousMobileId: $partnerAgentSuspiciousMobileId
    ) {
      ok
    }
  }
`;
